<template>
    <header class="header" id="top">
        <div class="header__text-container u-text-center">
            <h1 class="header-primary">
                <span class="header-primary--main">as-salah</span>
                <span class="header-primary--sub">حَيَّ عَلَى ٱلصَّلَاة</span>
            </h1>
        </div>
    </header>
</template>
<script>
export default {
    
}
</script>